<div *ngIf="showSpinner$ | async" class="ui active dimmer fadeIn">
  <div class="ui loader"></div>
</div>
<div *ngIf="view$ | async as view" [ngSwitch]="view.mode" class="wrp">
  <div
    class="tattoo"
    *ngIf="tattooStyle$ | async as tattooStyle"
    [ngStyle]="tattooStyle"
    >{{ (videoAnalyticsData$ | async)?.username }}</div
  >
  <i
    *ngIf="(showingClickToPlayBtn$ | async) && view.mode === 1"
    (click)="clickToPlayBtn()"
    class="overlay-play-btn"
    floSvg="vid_play_icon"
    title="play video"
  ></i>
  <div *ngSwitchCase="0" class="error" [ngSwitch]="view.error.code">
    <div class="fadeIn">
      <flo-paywall
        *ngSwitchCase="vpsErrorCode.AUTHENTICATION_REQUIRED"
        [joinRoute]="'/create-account'"
      ></flo-paywall>
      <flo-paywall
        *ngSwitchCase="vpsErrorCode.UNAUTHORIZED"
        joinButtonTextOverride="Sign Up"
        loginButtonTextOverride="Already have an account?"
        [joinRoute]="'/create-account'"
      ></flo-paywall>
      <flo-paywall *ngSwitchCase="vpsErrorCode.FORBIDDEN" [joinRoute]="'/create-account'"></flo-paywall>
      <ng-container *ngSwitchCase="vpsErrorCode.STREAM_NOT_FOUND">
        <flo-video-error
          *ngIf="view.eventIsConcluded"
          title="The action has ended."
        >
          <p>Please select another stream.</p>
        </flo-video-error>
        <flo-video-error
          *ngIf="!view.eventIsConcluded"
          title="We couldn't find this stream."
        >
          <p>Please select another stream.</p>
        </flo-video-error>
      </ng-container>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.GEO_UNAVAILABLE"
        svg="location_blocked"
        title="Restricted Viewing Area"
      >
        <p>Unfortunately, this event is unavailable in your location.</p>
        <p>We apologize for the inconvenience.</p>
      </flo-video-error>

      <flo-video-error
        *ngSwitchCase="vpsErrorCode.REVOKED_SHARED_OR_MAX_CLIENT"
        [title]="view.error.message"
      >
        <p
          >Need more help? Click
          <a
            href="https://support.flosports.tv/s/article/Why-do-I-keep-getting-bumped-from-my-stream"
            target="_blank"
            >here.</a
          >
        </p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.REVOKED_BANNED_USER"
        title="You've been bumped"
      >
        <p
          >Please contact customer support at
          <a href="mailto:support@flosports.tv">support@flosports.tv</a>
        </p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.STREAM_COMPLETED"
        title="The action has ended."
      >
        <p>Please select another stream.</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.UNKNOWN_ERROR"
        title="An Error Occurred"
      >
        <p>Please select another stream.</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.PRE_AIR"
        title="This event has not started yet"
      >
        <p
          >
          Streaming begins at
          {{ view.error.meta?.eventStartAt | floLiveDateTime:isTbd }}.</p
        >
        <p *ngIf="view.error.message">{{ view.error.message }}</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.INTERMISSION"
        title="There's a break in the action"
      >
        <p
          >We'll be back at {{ view.error.meta?.eventStartAt | floLiveDateTime }}.</p
        >
        <p *ngIf="view.error.message">{{ view.error.message }}</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.CONCLUDED"
        title="The action is over."
      >
        <p *ngIf="view.error.message">{{ view.error.message }}</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.CONCLUDED_WITH_DVR"
        title="The action is over."
      >
        <p>Rewatch all the action here.</p>
        <p *ngIf="view.error.message">{{ view.error.message }}</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.CONCLUDED_FOR_DAY"
        title="Today's action is over."
      >
        <p *ngIf="view.error.message">{{ view.error.message }}</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchCase="vpsErrorCode.CONCLUDED_FOR_DAY_WITH_ARCHIVES"
        title="Today's action is over."
      >
        <p>Concluded. Check out the replays.</p>
        <p *ngIf="view.error.message">{{ view.error.message }}</p>
      </flo-video-error>
      <flo-video-error
        *ngSwitchDefault
        [title]="view.hlsLoader?.error?.message"
      >
        <p>Please select another stream.</p>
      </flo-video-error>
    </div>
  </div>
  <video
    #videoElement
    *ngSwitchCase="1"
    floDetectIosSafariFullscreen
    floMse
    playsinline
    floVideoAnalytics
    type="application/x-mpegURL"
    [src]="view.hlsLoader?.success?.hlsUrl"
    [videoAnalyticsData]="videoAnalyticsData$ | async"
    [attr.id]="videoReferenceId$ | async"
    (analyticsPlugin$)="analyticsPluginSource.next($event)"
    [floMseConfig]="floMseConfig"
    (floMseClientChange)="mseClientChanged($event)"
    (floMseClientMessageChange)="handleHlsMessages($event)"
  >
    <p>I'm sorry; your browser doesn't support HTML5 video.</p>
  </video>
  <ng-container *ngSwitchCase="1">
  <flo-video-ad
    *ngIf="newTokenRequested$ | async"
    [hlsInstance]="(hlsInstance$ | async)?.valueOrUndefined()"
    [videoAdLogPartial]="videoAdLogPartial$ | async"
    [analyticsPlugin]="analyticsPlugin$ | async"
    [authenticationToken]="authenticationToken$ | async"
    [contentVideoElement]="videoLoaded$ | async"
    [volumeControls]="volumeControls$ | async"
    [videoMeta]="videoMeta$ | async"
    [adParams]="view.hlsLoader?.success?.meta?.adParams"
    (adEvent$)="adEventSource.next($event)"
  ></flo-video-ad>
  </ng-container>
  <div class="preview-expiry fadeIn" *ngIf="view.countdown.showCountdown">
    <p class="flo-footnote"
      >Your preview ends in
      <span>{{ view.countdown.secondsRemaining | floTime }}</span>
    </p>
  </div>
</div>
